import { useCallback, useState } from 'react';

export function useExpandedQuoteIds() {
  const [expandedIds, setExpandedIds] = useState<Set<string>>(new Set());

  const toggleExpandedId = useCallback((id: string) => {
    setExpandedIds(previousIds => {
      const nextIds = new Set(previousIds);

      if (nextIds.has(id)) {
        nextIds.delete(id);
      } else {
        nextIds.add(id);
      }

      return nextIds;
    });
  }, []);

  return { expandedIds, toggleExpandedId };
}
